import { useEffect, useMemo, useRef, useState } from "react";
import TitlePage from "../../../../components/TitlePage";
import { Row, Col, Button, Form, InputGroup} from "react-bootstrap";
import { ConsultaTotvsEmpresa, ConsultaTotvsEmpresaIndividual } from "../../../../../backend/ConsultaTotvsEmpresa";
import ResponsiveDataTable from "../../../../components/DataTable";
import LoadingSpinner from "../../../../components/LoadinSpinner";
import InputGeral from "../../../../components/InputGeral/Index";

import HomologacaoFornecedores from "../../../../../lib/json/consultas/HomologacaoFornecedores.json"
import SelectEmpresa from "../../../../components/Select/Empresa";
import { useNavigate } from "react-router-dom";
import { format, startOfMonth, startOfYear } from "date-fns";
import { usePopUp } from "../../../../components/BootBox";
import { handleData, handleValorTotal } from "../../../../components/GridCell/Preco";
import SelectFornecedor from "../../../../components/Select/Fornecedor";
import SelectFixo from "../../../../components/SelectFixo";
import { useSessionStorageState } from "../../../../../hooks/useSessionStorageState";
import ExportarExcel from "../../../../components/ExportarExcel";
import { handleFornecedorNFColumn, handleFilialNotaFiscal, handleUsuarioInclusao, handleStatusNF } from "../../../../components/GridCell/NotaFiscal";
import ConsultaTotvs from "../../../../../backend/ConsultaTotvs";
import HomologacaoFornecedor from "../HomologacaoFornecedor";
import { CelBreak25, NormalFont } from "../../../../components/GridCell/styles";

function ListaHomologacaoFornecedores(){
    const { DisparaBootBox, FechaBootBox  } = usePopUp();
    // define a exibição do Loading
    var tabelasDefault  = HomologacaoFornecedores.tabelas;
    
    const refAvaliacao = useRef();
    const navigate = useNavigate();
    const currentDate = new Date()
    const firstDayOfYearDate = startOfYear(currentDate);
    const firstDayOfMonthDate = startOfMonth(currentDate);
    
    const [carregar, setCarregar] = useState(false);
    const [data, setData]   = useState([]);
    const [empresa, setEmpresa] = useSessionStorageState("homologacaoEmpresa",{value: '', text: ''});
    const [dateDe, setDateDe] = useSessionStorageState("homologacaoDateDe",format(firstDayOfYearDate, 'yyyy-MM-dd'));
    const [dateAte, setDateAte] = useSessionStorageState("homologacaoDateAte",format(currentDate, 'yyyy-MM-dd'));
    const [dateDeResposta, setDateDeResposta] = useSessionStorageState("homologacaoDateRespostaDe",format(firstDayOfMonthDate, 'yyyy-MM-dd'));
    const [dateAteResposta, setDateAteResposta] = useSessionStorageState("homologacaoDateRespostaAte",format(currentDate, 'yyyy-MM-dd'));
    const [campoFornecedor, setCampoFornecedor] = useSessionStorageState("homologacaoFornecedor",null);
    
    const excelColumns = [
        {
            Header: 'Questionario',
            accessor: "PTQ_NUM",
        },
        {
            Header: 'Fornecedor',
            accessor: "A2_COD",            
        },
        {
            Header: 'Loja Fornecedor',
            accessor: "A2_LOJA",            
        },
        {
            Header: 'Nome Fornecedor',
            accessor: "A2_NOME",            
        },
        {
            Header: 'Data Envio',
            accessor: 'PTQ_ENVIO',
            Cell: handleData
        },
        {
            Header: 'Data Resposta',
            accessor: 'PTQ_DATRES',
            Cell: handleData
        },
        {
            Header: 'Média',
            accessor: 'PTQ_MEDIA',
        },
        {
            Header: 'Profissional',
            acessor: 'PTQ_PROFI'
        },
        {
            Header: 'Telefone',
            acessor: 'PTQ_TELPRO'
        },
        {
            Header: 'Àrea / Obra / Parceiro',
            acessor: 'PTQ_AREA'
        }
    ];
    
    // Colunas do grid
    const columns = [
        {
            Header: 'Questionario',
            accessor: "PTQ_NUM",
        },
        {
            Header: 'Fornecedor',
            accessor: "A2_COD",
            Cell: (item) => { 
                const { A2_COD, A2_LOJA, A2_NOME, PTQ_MEDIA } = item.row.original
                
                return (
                    <>
                        <CelBreak25>
                            <NormalFont style={{ padding: '1vh 0' }}><strong>{A2_COD.trim()}/{A2_LOJA}</strong> - {A2_NOME.trim()} </NormalFont>
                        </CelBreak25>
                        <p><strong>Média: </strong>{PTQ_MEDIA}</p>
                    </>
                )
            }   
        },        
        {
            Header: 'Data Envio',
            accessor: 'PTQ_ENVIO',
            Cell: (item) => {
                const { PTQ_DATRES } = item.row.original
                const itResp = {value: PTQ_DATRES};
                
                return (
                    <>
                        <p>{handleData(item)}</p>
                        <p><strong>Resposta: </strong>{handleData(itResp)}</p>
                    </>
                )
            }
        },
        {
            Header: 'Profissional',
            accessor: 'PTQ_TELPRO',
            Cell: (item) => { 
                const { PTQ_PROFI, PTQ_TELPRO, PTQ_AREA } = item.row.original
                
                return (
                    <>
                        <p>{PTQ_PROFI.trim()}</p>
                        <p><strong>Telefone:</strong> {PTQ_TELPRO.trim()}</p>
                        <p><strong>Àrea:</strong> {PTQ_AREA.trim()}</p>
                    </>
                )
            }
        },
    ];

    // WHERE/filtros da consulta do grid
    const retornaConsultaDefault = () => {
        let consultaDefault = HomologacaoFornecedores.consulta;
        let consultaFiltro = '';
        
        if(dateDe) {
            consultaFiltro += "AND PTQ_ENVIO >= '"+dateDe.replaceAll('-','')+"' ";
        }
        if(dateAte) {
            consultaFiltro += "AND PTQ_ENVIO <= '"+dateAte.replaceAll('-','')+"' ";
        }
        if(dateDeResposta) {
            consultaFiltro += "AND PTQ_DATRES >= '"+dateDeResposta.replaceAll('-','')+"' ";
        }
        if(dateAteResposta) {
            consultaFiltro += "AND PTQ_DATRES <= '"+dateAteResposta.replaceAll('-','')+"' ";
        }
        if(campoFornecedor?.value) {
            consultaFiltro += "AND PTQ_FORNEC + PTQ_LOJA = '"+campoFornecedor.value+"' ";
        }

        consultaFiltro += " GROUP BY PTQ_NUM, PTQ_NUMQUE, A2_COD, A2_LOJA, A2_NOME, A2_CGC, PTQ_MEDIA, PTQ_ENVIO, PTQ_PROFI, PTQ_TELPRO, PTQ_AREA, PTQ_NOME, PTQ_DATRES "
        
        consultaDefault = consultaDefault.replace('CAMPOS', " PTQ_NUM, PTQ_NUMQUE, A2_COD, A2_LOJA, A2_NOME, A2_CGC, PTQ_MEDIA, PTQ_ENVIO, PTQ_PROFI, PTQ_TELPRO, PTQ_AREA, PTQ_NOME, PTQ_DATRES ")
        consultaDefault = consultaDefault.replace('FILTRO', consultaFiltro)

        return consultaDefault
    }

    // Processa consulta do grid
    const listaHomologacaoFornecedor = async () => {
        var consultaDefault = retornaConsultaDefault();
        let empresaFilial = empresa.value ? empresa.value.substr(0,window._env_?.REACT_APP_TAMANHO_EMPRESA) + '-' + empresa.value.substr(-window._env_?.REACT_APP_TAMANHO_FILIAL) : ''

        setCarregar(true);
        var retConsulta = await ConsultaTotvs( consultaDefault, tabelasDefault, empresaFilial );
        setData(retConsulta.data);
        setCarregar(false);
    }

    useEffect( () => {
        listaHomologacaoFornecedor()
    },[])

    const handleVisualizar = async(row) =>{
        const {A2_COD, A2_LOJA, A2_NOME} = row.original
        // Renderiza o componente diretamente no BootBox
        DisparaBootBox(
            `Homologação Fornecedor: ${A2_COD + '/' + A2_LOJA + ' - ' + A2_NOME.trim()}`,
            () => <HomologacaoFornecedor dadosHomologacao={row.original} />,
            [
                { variant: 'light', action: FechaBootBox, label: '↩ Voltar' }
            ],
            null,
            false,
            'xl',
            true,
            true // withComponent = true
        );
        
        //Verifica se deve "Avaliar" e realiza o Questionário 
        return false
    }

    const excelHeaders = useMemo(() => {
        return excelColumns.map(col => col.Header);
    }, [excelColumns]);

    const excelRows = useMemo(() => {
        return data.map(item =>
            excelColumns.map(col => {
                const value = item[col.accessor];

                if (col.Cell) {
                    return col.Cell({ value, row: { original: item } });
                }
                return value ?? ""; // valor padrão se undefined/null
            })
        );
    }, [data, excelColumns]);

    return (
        <>
            <Row>
                <LoadingSpinner isLoading={carregar}/>
                <Col md="12" xs="12">
                    <TitlePage text="Homologação Fornecedor" exibirIncluir={false}/>
                </Col>
                <Col md='3'>
                    <SelectEmpresa
                        campoEmpresa={empresa}
                        onChangeEmpresa={setEmpresa}
                    />
                </Col>
                <Col md="9" xs="12">
                    <SelectFornecedor
                        campoFornecedor={campoFornecedor}
                        changeFornecedor={setCampoFornecedor}
                        empresaLogada={empresa.value}
                    />
                </Col>                
            </Row>
            <Row>
                <Col md="3" xs="12">
                    <InputGeral
                        label="Data Envio de"
                        tipo='date'
                        value={dateDe}
                        onChange={(e) => setDateDe(e.target.value)}
                    />
                </Col>
                <Col md="3" xs="12">
                    <InputGeral
                        label="Data Envio até"
                        tipo='date'
                        value={dateAte}
                        onChange={(e) => setDateAte(e.target.value)}
                    />
                </Col>
                <Col md="3" xs="12">
                    <InputGeral
                        label="Data Resposta de"
                        tipo='date'
                        value={dateDeResposta}
                        onChange={(e) => setDateDeResposta(e.target.value)}
                    />
                </Col>
                <Col md="3" xs="12">
                    <InputGeral
                        label="Data Resposta até"
                        tipo='date'
                        value={dateAteResposta}
                        onChange={(e) => setDateAteResposta(e.target.value)}
                    />
                </Col>                
            </Row>
            <Row className="d-flex justify-content-end">
                <Col md="3" xs="12">
                    <Button 
                        variant="outline-primary" 
                        type="submit" 
                        onClick={listaHomologacaoFornecedor}
                        className="w-100"
                    >
                        Buscar
                    </Button>
                </Col>
                <Col md="3" xs="12">
                    <ExportarExcel 
                        nomeArquivo="Nota_Fiscal"
                        headers={excelHeaders}
                        rows={excelRows}
                    />
                </Col>
            </Row>
            
            <Row>
                <Col md="12" xs="12">
                    <ResponsiveDataTable 
                        columns={columns} 
                        data={data} 
                        buttons={[
                            {isVisual: true, action: handleVisualizar, label: "Visualizar", icone: "MdOutlinePreview", style: "light"}, 
                        ]}
                        paginacao={100}
                    />
                </Col>
            </Row>
        </>
    );
}

export default ListaHomologacaoFornecedores;